import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import i18n from '@/src/i18n';
interface NoTutorialFoundProps {
  onBrowseAll: () => void;
}
export const NoTutorialFound = t0 => {
  const $ = _c(9);
  const {
    onBrowseAll
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image className="pb-6 pt-2" src="/images/icons/tutorials/not-found.svg" alt="Tutorial" width={154} height={116} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1 className="mb-2 text-2xl font-semibold text-gray-900">{i18n.t("No Tutorials Found")}!</h1>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-8 max-w-md">{i18n.language === "en" ? <><p className="text-base text-gray-900">Check your spelling or try using different keywords.</p><p className="text-base text-gray-900">If you need help, feel free to contact us.</p></> : <p className="text-base text-gray-900">Verifica tu ortografía o intenta usar palabras clave diferentes. Si necesitas ayuda, no dudes en contactarnos.</p>}</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = i18n.t("Browse all tutorials");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onBrowseAll) {
    t5 = <button className="rounded-lg border-2 border-[#318AE5] bg-[#318AE5] px-7 py-2.5 font-semibold text-white duration-150 hover:opacity-90" onClick={onBrowseAll}>{t4}</button>;
    $[4] = onBrowseAll;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-[] hover:text-blue-600"><Link href="/contact-us">{i18n.t("Contact us")}</Link></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="flex min-h-[400px] flex-col items-center justify-center p-4 text-center">{t1}{t2}{t3}<div className="space-y-4">{t5}{t6}</div></div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};